
import {Enum} from '../../common/model/enum.model';
import {Helpers} from '../../common/helpers/helpers';

export class TipoContratto extends Enum {

  constructor(protected value: string) {
    super(value);
  }

  public static values(): TipoContratto[] {
    return [
      new TipoContratto('TRIMESTRALE'),
      new TipoContratto('CONTRATTO_LAVORO_DIR_PRIVATO'),
      new TipoContratto('PERSONALE_COMANDATO_ESTERNO'),
      new TipoContratto('TEMPO_INDETERMINATO'),
      new TipoContratto('TEMPO_DETERMINATO'),
      new TipoContratto('ASSOCIATO_PRE_PROVV_N_83_2016'),
      new TipoContratto('DOTTORANDO'),
      new TipoContratto('BORSISTA'),
      new TipoContratto('ASSEGNISTA'),
      new TipoContratto('SPECIALIZZANDO'),
      new TipoContratto('INCARICATO_DI_RICERCA'),
      new TipoContratto('PROFESSORE_VISITATORE'),
      new TipoContratto('COLLABORATORE_PROFESSIONALE'),
      new TipoContratto('SALARIATO_AGRICOLO'),
      new TipoContratto('ALTRO'),
      new TipoContratto('DIRETTORE_NON_DIPENDENTE_CNR'),
      new TipoContratto('STAGE'),
      new TipoContratto('TIROCINANTE'),
      new TipoContratto('ANALISTA_DI_LABORATORIO'),
      new TipoContratto('SUPPORTO_INFORMATICO'),
      new TipoContratto('ATTIVITA_DI_FORMAZIONE'),
      new TipoContratto('OPERATORE_HELP_DESK'),
      new TipoContratto('DIPENDENTE_IMT'),
      new TipoContratto('ASSOCIATO_CON_INCARICO_DI_RICERCA'),
      new TipoContratto('ASSOCIATO_CON_INCARICO_DI_COLLABORAZIONE'),
      new TipoContratto('ASSOCIATO_CON_INCARICO_DI_COLLABORAZIONE_SENIOR'),
      new TipoContratto('DIPENDENTE_IN_COMANDO_DA_ALTRA_AMMINISTRAZIONE_SENZA_ONERI'),
      new TipoContratto('DIRETTORE_CONSORZIO_RFX'),
      new TipoContratto('REFERENTE_PARTECIPATA'),
      new TipoContratto('PERSONALE_IN_COMANDO'),
      new TipoContratto('MEMBRO_CDA'),
      new TipoContratto('MEMBRO_COMMISSIONE_DI_VALUTAZIONE'),
      new TipoContratto('DIRIGENTE_IN_COMANDO'),
      new TipoContratto('ASSOCIATO_CON_INCARICO_DI_RICERCATORE_EMERITO')
    ];
  }

}
